// extracted by mini-css-extract-plugin
export default {"pagination":"main_pagination__TM1S3","page-btn":"main_page-btn__+ULDk","active-page":"main_active-page__NkdmE"};